// ======================================================================
// File Name       : DrillByStdUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { AUTH_REDIRECT_URL, DRILL_CLIENT_URL, X_SSAPI_VERSION } from '../constants';
import store from '../store';

export async function getQuestionHistoryReviewHtml(params) {
  const state = store.getState();
  const { authedUser } = state.authed;
  if (params.drillStartDate) {
    params.drillStartDate = String(params.drillStartDate)
    .replace(' ', '%20');
  }
  // #7155 START
  let url = `${DRILL_CLIENT_URL}/QuestionHistoryReviewHtml`;
  url += `?institution_id=${authedUser.institutionId}`;
  url += `&drill_secern_id=${params.drillSecernId}`;
  url += `&question_secern_id=${params.questionSecernId}`;
  url += `&user_secern_id=${params.userSecernId}`;
  url += `&drill_start_date=${params.drillStartDate}`;
  url += `&auth_redirect_uri=${AUTH_REDIRECT_URL}`;
  url += `&X-SSapi-version=${X_SSAPI_VERSION}`;
  // #7155 END
  return url;
}
